import {Injectable, Injector} from "@angular/core";
import {MixAndMatchScheduleData} from "./mix-and-match-schedule.data";
import {PricingScheduleEntityModel} from "../pricing-schedule/pricing-schedule-entity.model";

@Injectable()
export class MixAndMatchScheduleEntityModel extends PricingScheduleEntityModel<MixAndMatchScheduleData> {
    constructor(injector: Injector) {
        super(injector, MixAndMatchScheduleData);
    }

    protected override onBeforeSaveEntity(entityData: MixAndMatchScheduleData) {
        super.onBeforeSaveEntity(entityData);
        entityData.allTerminals = !entityData.terminals.length;
    }
}
